import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { MobileService } from '../services/mobile-bridge/mobile.service';
import { TranslationService } from '../services/translation/translation.service';

export function fmaAuthGuard(): CanActivateFn {

  return async () => {
    const mobileService = inject(MobileService);
    const translationService = inject(TranslationService);

    if(sessionStorage.getItem('accessToken')) {
      await loadBackendTranslations(translationService);
      return true;
    }

    const hasToken = await getMobileBridgeToken(mobileService);

    if (hasToken) {
      await loadBackendTranslations(translationService);
    }

    return hasToken;
  }
}


async function loadBackendTranslations(translationService: TranslationService): Promise<void> {
  await firstValueFrom(translationService.loadTranslations());
}

export async function getMobileBridgeToken(mobileService: MobileService) {
  const nativeBridge = mobileService.getNativeBridge();

  if (!nativeBridge) {
    return noTokenFound();
  }

  const token = await nativeBridge.getCatBundle();

  if(!token) {
    return this.noTokenFound();
  }

  sessionStorage.setItem('accessToken', token.access_token);

  return true;
}

export function noTokenFound() {
  console.log('env: ',environment.environment);
  if(environment.environment === 'PROD') {
    window.alert('SVS is not available in this environment. Please use the app to access SVS.');
    return false;
  }
  const token = window.prompt('CAT Token');

  if(!token) {
    return false;
  }

  sessionStorage.setItem('accessToken', token);
  return true;
}
